<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container das-form-group">
        <el-row :gutter="16" class="das-form-row">
          <el-col :span="6" class="das-form-col">
            <div class="das-form-input">
              <div class="label">
                {{ 'Từ khóa' }}
              </div>
              <input v-model="queryParams.keyword" type="text" />
            </div>
          </el-col>
          <el-col :span="6" class="das-form-col">
            <div class="das-form-input">
              <div class="label">
                {{ 'Tài khoản' }}
              </div>
              <el-select v-model="queryParams.accountId" filterable clearable>
                <el-option
                  v-for="option in accounts"
                  :key="option.id"
                  :label="option.full_name"
                  :value="option.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="12" class="das-form-col">
            <el-row :gutter="16">
              <el-col :span="12">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Từ ngày' }}
                  </div>
                  <CalendarSelect v-model="queryParams.dateFrom" mode="date" />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Đến ngày' }}
                  </div>
                  <CalendarSelect v-model="queryParams.dateTo" mode="date" />
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="16" class="das-form-row">
          <el-col :span="6" class="das-form-col">
            <div class="das-form-input">
              <div class="label">
                {{ 'Bộ phận' }}
              </div>
              <el-select
                v-model="queryParams.objectId"
                clearable
                filterable
                @change="queryParams.actionId = null"
              >
                <el-option
                  v-for="option in departments"
                  :key="option.id"
                  :label="option.object_desc"
                  :value="option.object_id"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="das-form-col">
            <div class="das-form-input">
              <div class="label">
                {{ 'Hành động' }}
              </div>
              <el-select v-model="queryParams.actionId" clearable filterable>
                <el-option
                  v-for="option in filteredActions"
                  :key="option.object_action_id"
                  :label="option.object_action_desc"
                  :value="option.object_action_id"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll mt-10">
      <table class="master-detail-table">
        <thead>
          <th v-for="column in tableCols" :key="column.field">
            {{ column.headerName }}
          </th>
        </thead>
        <tbody ref="gridBody">
          <template v-for="row in tableRows">
            <tr :key="`record-data-${row.system_log_id}`" class="master-row">
              <td v-for="column in tableCols" :key="column.field">
                <template v-if="column.valueFormatter">
                  {{ column.valueFormatter({ value: row[column.field] }) }}
                </template>
                <template v-else>
                  {{ row[column.field] }}
                </template>
              </td>
            </tr>
            <tr :key="`record-desc-${row.system_log_id}`" class="detail-row">
              <td :colspan="tableCols.length" v-html="row.desc"></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
  </div>
</template>
<script>
import {
  listDepartment,
  listLog,
  listLogAction
} from '@/api/config-service/system-log.api'
import { CellRenderRowDetail } from '@/utils/cellRenders'
import { getUserApi } from '@/api/userConfig/user'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import paginationMixin from '@/mixins/paginationMixin'
import { notifyError } from '@/utils/toast'

export default {
  components: {
    CalendarSelect,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderRowDetail
  },
  mixins: [paginationMixin],
  props: {
    createUser: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      cellRenderRowDetail: null,
      isRowMaster: null,
      queryParams: {
        dateFrom: null,
        dateTo: null,
        objectId: null,
        actionId: null,
        keyword: null,
        accountId: null
      },
      tableRows: [],
      tableCols: [
        {
          headerName: 'Thời gian',
          cellRenderer: 'agGroupCellRenderer',
          field: 'time',
          valueFormatter: params => {
            return this.$moment(params.value).format('DD/MM/y HH:mm')
          }
        },
        {
          headerName: 'Bộ phận',
          field: 'object_desc'
        },
        {
          headerName: 'Loại',
          field: 'object_action_desc'
        },
        {
          headerName: 'Người thao tác',
          field: 'account_nm'
        },
        {
          headerName: 'Ghi chú',
          field: 'title'
        }
      ],
      departments: [],
      actions: [],
      accounts: []
    }
  },
  computed: {
    filteredActions() {
      if (!this.queryParams.objectId) {
        return this.actions
      }
      return this.actions.filter(
        el => el.object_id === this.queryParams.objectId
      )
    }
  },
  async created() {
    await this.fetchListAccount()
    await this.fetchListLogAction()
    await this.fetchListDepartment()
    this.isRowMaster = dataItem => {
      return true
    }
    this.cellRenderRowDetail = CellRenderRowDetail
    this.queryParams.dateFrom = this.date
    this.queryParams.dateTo = this.date
    this.queryParams.accountId = +this.createUser
    console.log('assign')
    await this.fetchListLog()
  },
  async mounted() {},
  methods: {
    validateFilterForm() {
      if (
        this.queryParams.keyword != null &&
        this.queryParams.keyword.length > 50
      ) {
        return this.$t('validation.maxLength', {
          field: 'từ khóa',
          length: 50
        })
      }

      if (this.queryParams.dateFrom > this.queryParams.dateTo) {
        return this.$t('validation.dateIsAfter', {
          afterDate: 'ngày kết thúc',
          date: 'ngày bắt đầu'
        })
      }
      return null
    },
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fetchListLog()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fetchListLog()
    },
    async onSearch() {
      this.pageParams.pageNum = 1
      await this.fetchListLog()
    },
    onResetSearch() {
      this.queryParams = {
        dateFrom: null,
        dateTo: null,
        objectId: null,
        actionId: null,
        keyword: null,
        accountId: null
      }
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = this.pageSizeOptions[0]
    },
    async fetchListAccount() {
      await getUserApi().then(res => {
        this.accounts = res.data.map(item => item.account)
      })
    },
    async fetchListLog() {
      this.loading = true
      console.log('fetch data')
      await listLog({
        pageNum: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize,
        ...this.queryParams
      })
        .then(res => {
          this.tableRows = res.data
          this.pageParams.totalPage = Math.ceil(res.total / res.page_size)
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
        })
        .finally(() => {
          this.loading = false
        })
      this.$refs.gridBody.scrollTop = 0
    },
    async fetchListLogAction() {
      await listLogAction().then(res => {
        console.debug(res)
        this.actions = res.data
      })
    },
    async fetchListDepartment() {
      await listDepartment().then(res => {
        this.departments = res.data
      })
    }
  }
}
</script>
<style scoped>
th {
  padding: 12px 12px;
  text-align: left;
  background-color: rgb(var(--das-color-primary));
}

th,
td {
  font-size: 14px;
  border: none;
  padding: 12px;
  border-left: none !important;
  border-bottom: 1px var(--ag-row-border-color, #d9dcde) solid;
}

.master-row td {
  padding: 12px !important;
}

.detail-row td {
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
tr.master-row {
  background-color: #edf5f1;
}
p {
  margin-top: none;
  margin-bottom: none;
}
.grid-scroll {
  min-height: 0;
}
.master-detail-table {
  user-select: none;
  height: 100%;
  display: block;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.master-detail-table tbody {
  min-height: 0;
  flex-grow: 1;
  display: block;
  overflow-y: auto;
}

thead,
tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed; /* even columns width , fix width of table too*/
}
</style>
